import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import {
  fetchApplicableTravelWalletItems,
  schedulePriceQuote,
  setPriceQuote,
} from "./actions/actions";
import { fetchVacationRentalShop } from "../shop/actions/actions";

import { IStoreState } from "../../reducers/types";
import { VacationRentalBook } from "./component";
import { getUserPassengerCallState, getUserPassengers } from "./reducer";
import {
  getVacationRentalShopCallState,
  getVacationRentalShopSelectedListing,
  getViewedVacationRentalDetailsProperties,
} from "../shop/reducer";

const mapStateToProps = (state: IStoreState) => {
  return {
    selectedHome: getVacationRentalShopSelectedListing(state),
    vacationRentalShopCallState: getVacationRentalShopCallState(state),
    travelers: getUserPassengers(state),
    userPassengerCallState: getUserPassengerCallState(state),
    viewedVacationRentalDetailsProperties:
      getViewedVacationRentalDetailsProperties(state),
  };
};

const mapDispatchToProps = {
  schedulePriceQuote,
  setPriceQuote,
  fetchApplicableTravelWalletItems,
  fetchVacationRentalShop,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type VacationRentalBookBookConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedVacationRentalBookBook = withRouter(
  connector(VacationRentalBook)
);
